"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getCreateEmailContentPanel;

var _preact = require("preact");

var _GenerateEmail = _interopRequireDefault(require("@insided/deprecated-control/EmailCampaigns/components/GenerateEmail"));

var _CreateEmailForm = _interopRequireDefault(require("@insided/deprecated-control/EmailCampaigns/components/CreateEmailForm"));

var _CreateEmailPreview = _interopRequireDefault(require("@insided/deprecated-control/EmailCampaigns/components/CreateEmailPreview"));

var _PanelHeaderWithIcon = require("@insided/deprecated-control/ui-components/PanelHeaderWithIcon");

var _Message = require("@insided/deprecated-control/ui-components/Message");

var _Button = _interopRequireDefault(require("@insided/shared/uikit/Button"));

var _common = require("@insided/shared/utils/common");

function getCreateEmailContentPanel(props) {
  var isEditEnabled = props.isEditEnabled,
      subject = props.subject,
      previewText = props.previewText,
      content = props.content,
      onSubjectChanged = props.onSubjectChanged,
      onPreviewTextChanged = props.onPreviewTextChanged,
      onContentChanged = props.onContentChanged,
      onSendTestEmail = props.onSendTestEmail,
      onEmailCreateDone = props.onEmailCreateDone,
      webmasterName = props.webmasterName,
      webmasterEmail = props.webmasterEmail,
      onPreviewClicked = props.onPreviewClicked,
      templateContent = props.templateContent,
      showCreateEmailEdit = props.showCreateEmailEdit,
      subjectError = props.subjectError,
      showGenerateEmailPanel = props.showGenerateEmailPanel,
      onGeneratePanelOpen = props.onGeneratePanelOpen,
      onGeneratePanelClose = props.onGeneratePanelClose,
      status = props.status,
      onInsert = props.onInsert;
  var title = isEditEnabled ? 'Create email' : 'Email content';
  var isDone = !!(subject && content && isEditEnabled);
  var generateButton = (0, _preact.h)(_Button.default, {
    key: "btn-generate-email",
    variant: "brand",
    className: "generate-button button-control__ai-secondary",
    startIcon: "aiStarsLinearGradient",
    title: "Generate",
    onClick: onGeneratePanelOpen,
    "data-track-type": "click",
    "data-element-name": "Generate email button"
  });
  var previewButton = (0, _preact.h)(_Button.default, {
    key: "btn-test-email",
    onClick: onSendTestEmail,
    "data-track-type": "click",
    "data-element-name": "Send test email button"
  }, (0, _preact.h)("span", null, "Send test email"));
  var editButtons = !showCreateEmailEdit ? [(0, _preact.h)(_Button.default, {
    key: "btn-edit",
    onClick: onPreviewClicked,
    "data-track-type": "click",
    "data-element-name": "Edit button"
  }, (0, _preact.h)("span", null, "Edit"))] : [(0, _preact.h)(_Button.default, {
    key: "btn-done",
    onClick: onEmailCreateDone,
    "data-track-type": "click",
    "data-element-name": "Done button"
  }, (0, _preact.h)("span", null, "Done"))];

  var isAiFeaturesEnabled = _common.common.isModuleActive('aiFeatures');

  var isAiFeaturesForCMEnabled = _common.common.isModuleActive('aiFeaturesForCM');

  var editModeButtons = isAiFeaturesEnabled && isAiFeaturesForCMEnabled ? [generateButton, previewButton, editButtons] : [previewButton, editButtons];
  var buttons = isEditEnabled ? editModeButtons : [previewButton];
  return {
    title: (0, _preact.h)(_PanelHeaderWithIcon.PanelHeaderWithIcon, {
      customClass: "panel-header-container",
      iconCustomClass: "icon-panel-header",
      icon: "editor",
      title: title,
      isDone: isDone && isEditEnabled,
      actions: buttons
    }),
    body: (0, _preact.h)("div", {
      className: "email-campaign-editor-container"
    }, (0, _preact.h)(_GenerateEmail.default, {
      isOpen: showGenerateEmailPanel,
      onClosePanel: onGeneratePanelClose,
      onInsert: onInsert
    }), isEditEnabled && showCreateEmailEdit ? (0, _preact.h)(_CreateEmailForm.default, {
      subject: subject,
      onSubjectChanged: onSubjectChanged,
      subjectError: subjectError,
      previewText: previewText,
      onPreviewTextChanged: onPreviewTextChanged,
      content: content,
      onContentChanged: onContentChanged,
      onEmailCreateDone: onEmailCreateDone
    }) : (0, _preact.h)(_CreateEmailPreview.default, {
      subject: subject,
      previewText: previewText,
      content: content,
      fromUsername: webmasterName,
      fromEmail: webmasterEmail,
      template: templateContent,
      isolatedContent: true,
      onSubjectClick: onPreviewClicked,
      status: status
    }), (0, _preact.h)("div", {
      className: "panel-email-disclaimer"
    }, (0, _preact.h)(_Message.Message, {
      variant: "info"
    }, (0, _preact.h)("span", null, "This preview approximates the email client-safe version of your email. Therefore some elements may be hidden or rendered differently than from the editor.", ' ')))),
    customClass: 'panel-email-campaign-editor',
    collapsible: false
  };
}